import { useNavigate } from 'react-router-dom'
import { InspectionService } from 'utility'
import { useNotification } from 'hooks/toast'

// Where every dashboard item goes. Audits open by their GUID (AuditGuid), like the task list does.
export const useHomeDashboardNavigation = () => {
    const navigate = useNavigate()
    const { errorToast } = useNotification()

    const openAudit = item => {
        if (!item?.AuditGuid) {
            navigate('/app/task')
            return
        }
        navigate(`/app/templates/inspection/${item.AuditGuid}`)
    }

    const openReport = async item => {
        if (!item?.AuditGuid) {
            errorToast('Could not open this report. Please open it from the task list.')
            return
        }
        // Open the tab first (pop-up blockers allow it only inside the click), then point it at the PDF.
        const win = window.open('', '_blank')
        if (!win) {
            errorToast('Your browser blocked the new tab. Allow pop-ups for this site to open the report.')
            return
        }
        win.opener = null
        try {
            const result = await InspectionService.getReport(item.AuditGuid)
            if (result?.ReportPath) {
                win.location.href = result.ReportPath
            } else {
                win.close()
                errorToast('The report PDF is not ready yet.')
            }
        } catch {
            win.close()
            errorToast('Could not open this report. Please try again.')
        }
    }

    const openTicket = id => {
        if (id) navigate(`/app/ticket/${id}`)
        else navigate('/app/tickets')
    }

    const openInboxItem = (group, item) => {
        const kind = String(item?.Kind || '').toLowerCase()
        const key = String(group?.Key || '')
        if (kind === 'ticket') return openTicket(item.Id)
        if (kind === 'digest' || key === 'digest') return navigate('/app/consolidated-report-email')
        if (kind === 'task' && !item?.AuditGuid) return navigate('/app/task')
        return openAudit(item)
    }

    // "All" link of an inbox group; null = no list page for it
    const groupListPath = group => {
        switch (String(group?.Key || '')) {
            case 'overdueTasks':
            case 'drafts':
                return '/app/task'
            case 'ticketsPastDue':
            case 'escalated':
            case 'ticketsToAcknowledge':
                return '/app/tickets'
            case 'digest':
                return '/app/consolidated-report-email'
            default:
                return null
        }
    }

    const openActivity = item => {
        if (item?.TicketId) return openTicket(item.TicketId)
        if (String(item?.Kind || '').toLowerCase() === 'completed') return openReport(item)
        return openAudit(item)
    }

    return {
        navigate,
        openAudit,
        openReport,
        openTicket,
        openInboxItem,
        openActivity,
        groupListPath,
        startNew: () => navigate('/app/templates'),
        openTasks: () => navigate('/app/task'),
        openSettings: () => navigate('/app/settings/home-dashboard'),
    }
}
